import * as prosConnect from "./ProsConnect"
import {API} from "aws-amplify";
import {
    prosLog,
    prosLogDt,
    prosLogClearDt,
    reserveAwsApi,
    makeAwsReqParams,
    checkAwsApiException
} from "./ProsConnect"
import {ATTR_WEB_OPERATION, WEB_OPER_MAKE_PROJ} from "./ProsConnect"
import {DEBUG_LOG_SENDING_TO_AWS} from "./ProsConnect"
import {prosLogX} from "./ProsConnect"
import {dumpObjToJsonFile} from "./ProsConnect"

const DEBUG_SAVE_USERS_AND_PROJECTS = false;

export async function deleteProject(projectAttrs) {
    prosLog('ProjecManagement:deleteProject()');
    let isActiveProject = false;
    if (!projectAttrs) {
        isActiveProject = true;
        projectAttrs = prosConnect.getActiveProject().attrs;
    }
    await prosConnect.getActiveProject().awaitRemoveItem(projectAttrs, false);
    if (isActiveProject) {
        prosConnect.deactivateActiveProject();
    }
}

export async function deleteMainProject(main_project_id, customer_group) {
    prosLog('ProjectManagement:deleteMainProject()');
    await prosConnect.awaitRemoveMainProject(main_project_id, customer_group);
}

// returns a list of user role objects
export function getActiveProjectUsers() {
    if (!prosConnect.getActiveProject()) {
        alert("Valitse ensin projekti");
        return [];
    }
    if(prosConnect.hasPermissionTo("editAdmin")) {
        return prosConnect.getActiveProject().getProjectUsers();
    }
}

// get all users from all projects for which user has admin right
//      customerGroup is used to separate customers into own pools
// returns
//      result     status OK
//      users      a list of objects each with name and email {email: x, name: y}
//      projects   a list of projects user authorisation objects
export async function awaitGetAllUsersAndProjects() {
    if (!prosConnect.getActiveProject()) {
        alert("Valitse ensin projekti");
        return [];
    }
    prosLogClearDt();
    prosLogDt('Getting list of all projects and users..');
    let email = prosConnect.getUserEmail();
    if (prosConnect.isSuperUserModeInUse()) {
        let testUserEMail = prosConnect.getCustomerTestEmail();
        if (testUserEMail) {
            email = testUserEMail;
        }
    }
    try {
        // server uses active project customerCode to select projects and their users
        await reserveAwsApi(true, 'GET customer projects')
        let response = await API.get("prodect",
            '/websynch?email=' + email
            + '&id=' + prosConnect.getDevId()
            + '&project=' + prosConnect.getActiveProject().getPid()
            + '&report=none'
            + '&oper=get_project_users'
        );
        await reserveAwsApi(false, 'GET customer projects')
        if (response && response.hasOwnProperty('result') && response.result === 'OK') {
            if (response.hasOwnProperty('users')) {
                prosLogDt('Users count', response.users.length);
            }
            if (response.hasOwnProperty('projects')) {
                prosLogDt('Project count', response.projects.length);
            }
            if (DEBUG_SAVE_USERS_AND_PROJECTS) {
                dumpObjToJsonFile(response, 'users-and-projects');
            }
            return response;
        }
    } catch (e) {
        prosConnect.prosLogErr(e)
    }
    await reserveAwsApi(false, 'GET customer projects-failed')
    return undefined;
}

// returns {result: OK} when succeeded
export async function awaitMakeNewProject(newMainProjectName, newProjectName,
                                          refPidForSettings, refPidForUsers, customerGroup,
                                          copyReports, copyObs, copyUsers, newProjectDescription) {
    prosLogDt('awaitMakeNewProject()',
        newMainProjectName, newProjectName,
        refPidForSettings, refPidForUsers, copyReports, copyObs, copyUsers)
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_MAKE_PROJ
    req['ref_pid'] = refPidForSettings
    req['ref_pid_users'] = refPidForUsers
    req['new_main_proj_name'] = newMainProjectName
    req['customer_group'] = customerGroup
    req['new_proj_name'] = newProjectName
    req['copy_reports'] = copyReports
    req['copy_obs'] = copyObs
    req['copy_users'] = copyUsers
    //Todo Jere: save to database -> req['new_prj_desc'] = newProjectDescription

    // Hint - when test changes to create a project use this to study expected API parameters
    // and enable server communication after checking parameters are as expected
    // console.log(req)
    // return 'remove-me'
    /* ------------------------------------------------------------------------------- */
    if ( DEBUG_LOG_SENDING_TO_AWS) {
        prosLogX("POST TO AWS - req new project")
        prosLogX(req)
    }
    try {
        // console.log("Make new project", req);
        await reserveAwsApi(true, 'POST req new project')
        let result = await API.post("prodect",'/webstore',{body: [req]})
        await reserveAwsApi(false, 'POST req new project')
        return result
    } catch (e) {
        checkAwsApiException(e)
    }
    await reserveAwsApi(false, 'POST req new project-failed')
    /* ------------------------------------------------------------------------------- */
}

